module.exports = __webpack_public_path__ + "img/vector.2875f842.png";